import MyThirdPartyFuneralPolicy from './MyThirdPartyFuneralPolicy'

export default MyThirdPartyFuneralPolicy
